import {h, Fragment} from "preact"
import { ProductV2 as Product, FeaturedItemV2 as FeaturedItem } from '../'
import { init, useAppState, useProductFilters } from "@nosto/preact";
import { useEffect, useState } from "preact/hooks";
import { useGridLayout } from "../../contexts/GridLayoutContext"



export default function Products({ listing }) {

    const { gridSize } = useGridLayout();

    return (
        <div className="grid collection-grid" data-abtest="tested" style={`--items-per-row: ${gridSize}`}>
            {listing.map((hit, index) => 
                (
                    hit.type === 'product' ?
                        <Product product={hit} key={`product-${hit.productId || index}`} />
                    :
                        <FeaturedItem data={hit} key={`banner-${index}`} />
                )
            )}
        </div>
    );
}
